// extracted by mini-css-extract-plugin
export default {"SingleViewer":"SingleViewer_SingleViewer__srCKg"};